import dayjs from 'dayjs';

export const isToday = (timestamp: number | string): boolean => {
  const date = dayjs(+timestamp);
  return date.isSame(dayjs(), 'day');
};
